import { clsx } from 'clsx';
import { FC } from 'react';

import UiTab, { TabProps as UiTabProps } from '@o2/ui/Tab';

import { useSubheaderUtilityClasses } from '../subheaderClasses';

type SubheaderTabProps = UiTabProps;

const Tab: FC<SubheaderTabProps> = ({ classes, ...props }) => {
  const utilityClasses = useSubheaderUtilityClasses(classes);

  return <UiTab className={clsx(utilityClasses.tab)} {...props} />;
};

Tab.displayName = 'Subheader.Tab';

export default Tab;
